var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SecondaryLayout',[_c('div',{staticClass:"container"},[_c('ShopperSelect',{on:{"profileSwitched":_vm.onProfileSwitch}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }